import { Header } from 'semantic-ui-react';
import React from 'react';

export default {
    demo: {
        todayIs: 'Danas je'
    },
    errors: {
        showAllErrors: 'Prikaži sve greške ({count})',
        hideErrors: 'Sakrij greške',
    },
    common: {
        clear: 'Očisti',
        bhs: 'B/H/S jezik',
        eng: 'Engleski jezik',
        group: 'Grupa',
        totalEcts: 'Ukupno ECTS bodova:',
        socialStatus: 'Socijalni status',
        academicStaff: 'Nastavno osoblje',
        notFound: 'Stranica ne postoji',
        courseRoleType: 'Uloga',
        courseDetails: 'Podaci o predmetu',
        details: 'Detalji',
        ordinal: 'R. br.',
        comment_: 'Napomena',
        logout: 'Odjava',
        editAdd: 'Dodavanje / izmjena',
        add: 'Dodaj',
        send: 'Pošalji',
        cancel: 'Poništi',
        cancelO: 'Odustani',
        ok: 'Potvrdi',
        firstName: 'Ime',
        lastName: 'Prezime',
        lastNameAndFirstName: 'Prezime i ime',
        studentLastNameAndFirstName: 'Prezime i ime studenta/ice',
        dateOfAbandonment: 'Datum ispisa',
        maidenName: 'Djevojačko prezime',
        student: 'Student/ica',
        index: 'Index',
        degree: 'Broj diplome',
        edit: 'Izmijeni',
        save: 'Sačuvaj',
        delete: 'Obriši',
        language: 'Jezik',
        comment: 'Napomena',
        date: 'Datum',
        courseName: 'Predmet',
        back: 'Nazad',
        confirm: 'Potvrdi',
        show: 'Prikaži',
        grade: 'Ocjena',
        teacher: 'Nastavnik',
        semester: 'Semestar',
        course: 'Predmet',
        courses: 'Predmeti',
        faculty: 'Fakultet',
        faculties: 'Fakulteti',
        academicYear: 'Akademska godina',
        municipality: 'Općina',
        unsa: 'Univerzitet u Sarajevu',
        studyCycle: 'Studijski ciklus',
        citizenship: 'Državljanstvo',
        process: 'Obrađuje se...',
        successfully: 'Uspješno...',
        studentsList: 'Popis studenata',
        graduatedDate: 'Datum diplomiranja',
        yes: 'DA',
        no: 'NE',
        areYouSure: 'Jeste li sigurni?',
        info: 'Informacije',
        userManualInfoTooltip: 'Klikom na ovakvu istu ikonicu u gornjem desnom uglu stranice, mo\u017eete pogledati detaljnije o ovom dijelu sistema u korisni\u010dkom uputstvu.',
        userManualInfoTooltipPrefix: 'Klikom na ikonicu',
        userManualInfoTooltipSuffix: 'u gornjem desnom uglu stranice, mo\u017eete pogledati detaljnije o ovom dijelu sistema u korisni\u010dkom uputstvu.',
        error: 'Došlo je do greške!',
        oneExamRestrictionError: 'Na ovom ispitnom roku možete prijaviti samo jedan ispit!',
        lecture: 'Predavanja (broj sati)',
        exercise: 'Vježbe (broj sati)',
        lectureExerciseSeminar: 'P + V + S',
        lectureExerciseSeminarAbr: 'P + V + S',
        select: 'Označi',
        chose: 'Odaberi',
        average: 'Prosjek',
        gradeAverage: 'Prosjek ocjena: ',
        studyProgram: 'Studijski program',
        studyType: 'Vrsta studija',
        contact: 'Kontakt',
        department: 'Odsjek',
        jmbg: 'JMBG',
        oid: 'OID',
        username: 'Korisničko ime',
        accountMail: 'Korisnički e-mail',
        dateOfBirth: 'Datum rođenja',
        gender: 'Spol',
        father: 'Ime i prezime oca',
        mother: 'Ime i prezime majke',
        fatherName: 'Ime oca',
        motherName: 'Ime majke',
        placeOfBirth: 'Mjesto rođenja',
        residence: 'Mjesto prebivališta',
        currentResidence: 'Mjesto boravišta',
        nationality: 'Nacionalnost',
        classroom: 'Učionica',
        noResultMessage: 'Nema pronađenih rezultata!',
        description: 'Opis/napomena',
        phone: 'Telefon',
        mail: 'E-mail',
        studyAddress: 'Adresa boravišta',
        cantonResidence: 'Kanton prebivališta',
        municipalityResidence: 'Općina prebivališta',
        addressResidence: 'Adresa prebivališta',
        archive: 'Arhiviraj',
        courseCode: 'Šifra predmeta',
        code: 'šifra',
        startPage: ' ',
        editOrAdd: 'Dodavanje / izmjena',
        coursesList: 'Popis predmeta',
        leadStaff: 'Nosilac predmeta',
        filterRequired: 'Morate unijeti po čemu želite filtrirati!',
        studyProgramName: 'Naziv smjera (studijskog programa)',
        selectStudyProgram: 'Odaberite smjer (studijski program)',
        inputIndex: 'Unesite broj indexa',
        inputName: 'Unesite ime',
        inputLastName: 'Unesite prezime',
        personalInfo: 'Osobni podaci',
        students: 'Studenti',
        courseType: 'Vrsta predmeta',
        mandatory: 'Obvezni',
        optional: 'Izborni',
        notice: 'Obavijesti',
        notification: 'Obavijest',
        notifications: 'Notifikacije',
        allNotificationsTitle: 'Prikaz svih notifikacija',
        viewAllNotifications: 'Sve notifikacije',
        newNotificationsMore: 'novih notifikacija – pogledajte sve',
        filterUnread: 'Samo nepročitane',
        filterAll: 'Sve',
        loadMore: 'Učitaj narednih {count}',
        selectAllToSeeRead: 'Odaberite opciju "Sve" da vidite sve prethodne pročitane notifikacije.',
        markAllAsReadHint: 'Klikom označavate sve nepročitane notifikacije kao pročitane. Ostat će vidljive, ali se više neće prikazivati kao nove.',
        inputNotification: 'Unesite obavijest..',
        newNotifications: 'Nove obavijesti',
        newNotification: 'Nova obavijest',
        markAllAsRead: 'Označi sve kao pročitano',
        new: 'NOVO',
        activeNotifications: 'Aktivne obavijesti',
        previousNotifications: 'Prethodne obavijesti',
        noNewNotifications: 'Nemate novih notifikacija.',
        noActiveNotifications: 'Nemate aktivnih obavijesti',
        noPreviousNotifications: 'Nemate prethodnih obavijesti',
        title: 'Naslov obavijesti',
        notificationType: 'Vrsta obavijesti',
        notificationStartDate: 'Datum objave',
        notificationEndDate: 'Datum isteka',
        recipientsProfessors: 'Primatelji obavijesti (Profesori)',
        recipientsEmployees: 'Primatelji obavijesti (Zaposlenici)',
        recipientsStudents: 'Primatelji obavijesti (Studenti)',
        requiredFields: 'Niste popunili sva obvezna polja.',
        requiredEmailForm: 'Unesite ispravnu email adresu.',
        notificationSent: 'Obavijest je uspješno poslana.',
        notificationSentError: 'Došlo je do greške! Slanje obavijesti nije uspješno izvršeno.',
        employees: 'Zaposlenici',
        professors: 'Profesori',
        section: 'Sekcija',
        intervalStart: 'Od',
        intervalEnd: 'Do',
        image: 'Fotografija studenta',
        semesterName: 'Naziv semestra',
        semesterNumber: 'Broj semestra',
        applicationDate: 'Datum prijave ispita',
        english: 'Engleski jezik',
        bosnian: 'B / H / S',
        startEngagement: 'Početak angažmana',
        endEngagement: 'Kraj angažmana',
        titleElection: ' Izbor u zvanje',
        academicTitle: 'Zvanje',
        titleExpiration: 'Istek zvanja',
        noEmploymentInfo: 'Podaci o zvanju zaposlenika nisu uneseni. Obratite se HR administratoru.',
        noPositionInfo: 'Podaci o poziciji zaposlenika nisu uneseni. Obratite se HR administratoru.',
        filterStudents: 'Pretraga studenata',
        noData: 'Nema podataka',
        noDataToDisplay: 'Nema podataka za prikaz.',
        enrolmentCountInSemester: 'Broj upisa u trenutni semestar',
        titleGender: 'Rod za titulu',
        debit: 'Dugovanje',
        notificationsUnavailable: 'Obavijesti privremeno nisu dostupne.',
        systemUserGuide: 'Pregledaj korisničko uputstvo',
        droppedOut: 'Ispisan student',
        locked: 'Zaključan student',
        ects: 'ECTS',
        noNotificationText: 'Nema teksta.',
        assistants: 'Asistenti',
        demonstrators: 'Demonstratori',
        laborants: 'Laboranti',
        associates: 'Suradnici',
        userAccounts: 'Korisnički računi',
        academicStaffList: 'Popis nastavnog osoblja',
        organizationalUnit: 'Organizacijska jedinica',
        selectOrganizationalUnit: 'Odaberite organizacijsku jedinicu',
    },
    scholarship: {
        scholarship: 'Stipendije',
        scholarshipCode: 'Kod za stipendiju',
    },
    poll: {
        poll: 'Anketa',
        polls: 'Ankete',
        access: 'Pristup',
        accessProhibited: 'zabranjen',
        accessGranted: 'odobren',
        ban: 'Zabrani',
        approve: 'Odobri',
        results: 'Rezultati',
        pollResults: 'Rezultati ankete',
        reviewResults: 'Pregled rezultata',
        question: 'Pitanje',
        questions: 'Pitanja',
        active: 'Aktivne ankete',
        created: 'Kreirane ankete',
        archived: 'Arhivirane ankete',
        pollTitle: 'Naziv ankete',
        title: 'Naziv',
        type: 'Vrsta',
        startDate: 'Datum objave',
        endDate: 'Datum isteka',
        pollDetails: 'Detalji ankete',
        details: 'Detalji',
        edit: 'Uredi',
        delete: 'Obriši',
        overview: 'Pregled anketa',
        createNewPoll: 'Kreiraj novu anketu',
        newPoll: 'Nova anketa',
        creatingPoll: 'Kreiranje ankete',
        pollType: 'Vrsta ankete',
        comment: 'Komentar',
        placeholderPollName: 'Unesite naziv',
        placeholderType: 'Odaberite vrstu',
        placeholderDate: 'Unesite datum',
        placeholderComment: 'Unesite komentar..',
        placeholderAnswer: 'Unesite odgovor',
        placeholderQuestion: 'Unesite pitanje',
        placeholderOfferedAnswer: 'Unesite ponuđeni odgovor',
        createPollButton: 'Kreiraj anketu',
        cancel: 'Odustani',
        addQuestionButton: 'Dodaj pitanje',
        addAnswerButton: 'Dodaj odgovor',
        offeredAnswers: 'Ponuđeni odgovori',
        section: 'Sekcija',
        placeholderAssistants: 'Odaberite asistente',
        placeholderProfessors: 'Odaberite profesore',
        numberOfStudentsOnCourse: 'Broj studenata na predmetu',
        numberOfStudentsWhoDoneCourse: 'Broj studenata koji su ocijenili predmet',
        numberOfStudentsWhoDoneProfessor: 'Broj studenata koji su ocijenili profesora',
        numberOfStudentsWhoDoneAssistant: 'Broj studenata koji su ocijenili asistenta',
        coursesOnPoll: 'Popis predmeta na anketi',
        noCoursesMess: 'Vaši predmeti se ne nalaze na odabranoj anketi.',
        noPollMess: 'Trenutno nema kreiranih anketa.',
        noStudentsMess: 'Na odabranom predmetu nema studenata.',
        lateImplementationMess: ' Implementacija predmeta je kreirana nakon početka anketiranja.',
        noCoursesAssigned: 'Niste dodijeljeni na predmete u ovom semestru.',
        sp: 'Smjer',
        noDataForExcelExport: 'Došlo je do greške. Nema podataka za Excel izvoz.',
        errorWhileExcelExport: 'Došlo je do greške prilikom izvoza u Excel datoteku.',
        successfullExcelExport: 'Uspješno ste izvezli podatke u Excel datoteku.',
        index: 'R. br.',
        startDateStudents: 'Datum objave studentima',
        voluntaryParticipationNotice: '* Vaše sudjelovanje u anketi je potpuno dobrovoljno, a Vaši odgovori ostaju povjerljivi i anonimni. Podaci prikupljeni anketom bit će prikazani samo kao statistički podaci. Vaši iskreni i objektivni odgovori mogu biti pokazatelj dobrih praksi ili ukazati na eventualne nedostatke i poteškoće u procesu realizacije nastavnih aktivnosti te utjecati na poboljšanje njihove buduće kvalitete.',
        selectStaffForCourse: 'Odaberite profesore i asistente predmeta ({courseName}):',
        assistantGradingOptionalNotice: '* Ocjenjivanje asistenta nije obavezno, ukoliko odmah ne odaberete i asistenta naknadno ga nećete moći ocijeniti.',
        professorsLabel: 'Profesor/i:',
        assistantsLabel: 'Asistent/i:',
        continueButton: 'Nastavi',
        noProfessorsAssigned: 'Nema dodijeljenih profesora ovom predmetu.',
        connectStudentToCourseError: 'Došlo je do pogreške prilikom povezivanja studenta s predmetom.',
        connectStudentToDirectionError: 'Došlo je do pogreške prilikom povezivanja studenta sa smjerom.',
        alreadyAnswered: 'Već ste odgovorili na ovu anketu.',
        errorFetchingQuestions: 'Došlo je do pogreške. Nije moguće prikazati pitanja.',
        questionWithoutOptions: 'Pitanje nema ponuđene odgovore: {text}',
        answersSentSuccess: 'Odgovori su uspješno poslani.',
        errorSendingAnswers: 'Došlo je do pogreške, niste poslali odgovore.',
        notAllAnswered: 'Niste unijeli sve odgovore.',
        noQuestionsInPoll: 'Anketa nema pitanja!',
        noQuestions: 'Nema pitanja',
        sendAnswersButton: 'Pošalji odgovore',
        status: 'Status',
        evaluated: 'ocijenjen',
        notEvaluated: 'neocijenjen',
        evaluateButton: 'Ocijeni',
        notEnrolledCurrentSemesterMessage: 'Niste upisani u trenutni semestar, te iz tog razloga ne možete vidjeti predmete i pristupiti anketi. Obratite se studentskoj službi fakulteta/akademije.',
    },
    sidebar: {
        home: 'Početna',
        personalInfo: 'Osobni podaci',
        study: 'Studij',
        gradesOverview: 'Ocjene',
        coursesOverview: 'Nastavni plan i program',
        collision: 'Kolizioni predmeti',
        optional: 'Izborni predmeti',
        currentSemesterCourses: 'Trenutni semestar',
        exams: 'Ispiti',
        activeExams: 'Aktivni ispiti',
        finalizedExams: 'Završeni ispiti',
        register: 'Prijava ispita',
        registeredExams: 'Prijavljeni ispiti',
        documents: 'Dokumenti',
        reports: 'Izvještaji',
        comment: 'Komentari i prijedlozi',
        contact: 'Kontakt informacije',
        courses: 'Predmeti',
        statistic: 'Statistika',
        announcements: 'Obavještenja',
        foreignStudents: 'Dolazne mobilnosti',
        searchForeignStudents: 'Pretraga studenata',
        createForeignStudents: 'Kreiranje studenta',
        registrationLinks: 'Registracijski linkovi',
        nonCycleProgram: 'Neciklični studij',
        nonCycleStudents: 'Pretraga studenata',
        nonCyclePrograms: 'Neciklični programi',
        nonCycleProgramLead: 'Voditelj programa',
        createNonCycleStudent: 'Kreiranje studenta',
        grading: 'Ocjenjivanje',
        mentorships: 'Mentorstva',
    },
    route: {
        home: 'Početna',
        personalInfo: '/osobni-podaci-studenta',
        collisionCourses: '/kolizioni-predmeti',
        optionalCourses: '/izborni-predmeti',
        currentSemesterCourses: '/predmeti-u-trenutnom-semestru',
        gradesOverview: '/pregled-ocjena',
        coursesOverview: '/nastavni-plan-i-program',
        passedExams: '/položeni-ispiti',
        registerExams: '/prijava-ispita',
        registeredExams: '/prijavljeni-ispiti',
        requests: '/dokumenti',
        reports: '/izvjestaji',
        comments: '/komentari-i-prijedlozi',
        contact: '/kontakt-informacije',

        finalized: '/završeni-ispiti',
        studentGrades: '/završeni-ispiti/popis-studenata',
        examStatistic: '/završeni-ispiti/statistika',
        active: '/aktivni-ispiti',
        inputGrades: '/aktivni-ispiti/unos-ocjena',
        filterStudentsForProfessor: '/studenti',
        studentsInfoFromSearch: '/studenti/profil',
        studentGradesAndInfo: '/aktivni-ispiti/unos-ocjena/podaci-o-studentu',
        studentGradesAndInfoFromFinalised: '/završeni-ispiti/popis-studenata/podaci-o-studentu',
        upcomingExams: '/predstojeći-ispiti',
        statistic: '/statistika-za-profesore',
        personalInf: '/osobni-podaci',
        courses: '/popis-predmeta',
        studentsInfo: '/popis-predmeta/studenti/podaci',
        studentsInfoSS: '/nastavno-osoblje/predmeti/studenti/detalji',
        students: '/popis-predmeta/studenti',
        courseDetails: '/popis-predmeta/detalji',
        courseStudents: '/popis-predmeta/studenti',
        courseStatistic: '/popis-predmeta/statistika',
        registeredStudents: '/prijavljeni-studenti',
        academicStaff: '/nastavno-osoblje',

        polls: '/ankete',
        pollCourses: '/ankete/predmeti',
        pollResults: '/ankete/predmeti/rezultati',
        access: '/pristup-anketi',
        accessCourses: '/pristup-anketi/predmeti',
        accessStudents: '/pristup-anketi/predmeti/studenti',
        faq: '/pitanja-i-odgovori',
        mentorships: '/mentorstva',


    },
    orgUnitDetailed: {
        orgUnits: 'Organizacione jedinice',
        parents: 'Roditelji',
        types: 'Tipovi',
        addOrgUnitType: 'Dodaj tip',
        staffPosition: 'Pozicija',
        staff: 'Staff',
        addresses: 'Adrese',
        addressesDesc: 'Sve adrese ove organizacione jedinice',
        street: 'Ulica',
        place: 'Mjesto',
        contacts: 'Kontakti',
        addContacts: 'Dodaj kontakt',
        contactValue: 'Vrijednost',
        contactDescription: 'Opis',
        contactType: 'Tip',
        name: 'Ime',
        errors: {
            changeName: 'Greska pri promjeni imena organizacione jedinice',
            gettingHierarchy: 'Greska pri dobavljanju hijerarhije',
            gettingOrgUnitDetails: 'Greska pri dobavljanju organizacione jedinice',
            gettingContactType: 'Greska pri dobavljanju tipova kontakta',
            addingContact: 'Greska pri dodavanju kontakta',
            deletingContact: 'Greska pri brisanju kontakta',
            creatingOrgUnit: 'Greska pri kreiranju organizacione jedinice',
            gettingOrganizationalUnits: 'Greska pri dobavljanju organizacionih jedinica',
            addingParent: 'Greska pri dodavanju roditelja',
            gettingPositions: 'Greska pri dobavljanju pozicija',
            gettingEmployees: 'Greska pri dobavljanju zaposlenika',
            mustHaveType: 'Ne moze se dodati zaposlenik ako nema tip organizacione jedinice',
            addingStaff: 'Greska pri dodavanju staff',
            gettingOrgUnitTypes: 'Greska pri dobavljanju tipova',
            addingOrgUnitTypes: 'Greska pri dodavanju tipova'
        }
    },
    mentorships: {
        title: 'Mentorstva i komisije',
        overview: 'Pregled mentorstava i učešća u komisijama',
        role: 'Uloga',
        studentName: 'Ime i prezime studenta',
        studyProgram: 'Studijski program',
        organizationalUnit: 'Organizaciona jedinica',
        thesisTopic: 'Tema',
        thesisTopicEn: 'Tema na engleskom',
        academicYear: 'Akademska godina',
        themeApprovalDate: 'Datum odobrenja teme',
        grade: 'Ocjena',
        successfullyDefended: 'uspješno odbranio',
        notDefended: 'nije odbranio',
        didNotAttend: 'nije pristupio/la',
        defenseDate: 'Datum odbrane',
        selectAcademicYear: 'Odaberite akademsku godinu',
        selectRole: 'Odaberite ulogu',
        noData: 'Nema podataka.',
        downloadExcel: 'Preuzmi spisak u Excel-u',
        excelFileName: 'Mentorstva i komisije',
        excelSheetName: 'Mentorstva'
    },
    student: {
        exams: 'Ispiti',
        canceled: 'Uspješno ste odjavili ispit.',
        registered: 'Uspješno ste prijavili ispit.',
        summerSemester: 'Ljetni semestar',
        winterSemester: 'Zimski semestar',
        studyProgramView: 'Nastavni plan i program',
        collision: 'Kolizija',
        availableCollision: 'Dostupni kolizioni predmeti',
        theRestEcts: 'Preostalo ECTS: ',
        currentCourses: 'Odabrani izborni predmeti',
        currentSemesterCourses: 'Predmeti u trenutnom semestru',
        noCollisionMessage: 'Trenutno predmete koje možete koliziono prijaviti.',
        noCoursesMessage: 'Nemate odabranih izbornih predmeta.',
        noCurrentSemesterMessage: 'Niste upisani u trenutni semestar, te iz tog razloga ne možete vidjeti predmete. Obratite se studentskoj službi fakulteta/akademije.',
        selectOptionalCourse: 'Potvrdi izbor',
        optionalCourses: 'Izborni predmeti',
        availableOptionalCourses: 'Dostupni izborni predmeti',
        noElectiveMessage: 'Trenutno nemate predmete koje možete prijaviti kao izborne predmete.',
        study: 'Studij',
        showGrades: 'Pregled ocjena',
        noGradesMessage: 'Nemate ocjena.',
        deleteContactToast: 'Kontakt je uspješno obrisan!',
        editContactToast: 'Kontakt je uspješno izmijenjen!',
        editContactErrToast: 'Došlo je do greške! Kontakt nije izmijenjen!',
        addContactToast: 'Kontakt je uspješno dodat!',
        basicInfo: 'Osnovni podaci',
        previousEducation: 'Prethodno obrazovanje',
        consentInfo: 'Saglasan/na sam da se moji kontakt podaci prikazuju nastavnom osoblju Univerziteta u Sarajevu.',
        currentStudy: 'Trenutni studij',
        examDate: 'Datum polaganja',
        registeredExams: 'Prijavljeni ispiti',
        noRegisteredExamsMessage: 'Nemate prijavljenih ispita.',
        currentRegisteredExams: 'Trenutno prijavljeni ispiti',
        allRegisteredExams: 'Prethodno prijavljeni ispiti',
        noPreviousRegisteredExamsMessage: 'Nemate prethodno prijavljenih ispita.',
        cancelExam: 'Odjavi ispit',
        registerExam: 'Prijava ispita',
        register: 'Prijavi ispit',
        noExamsForRegisterMessage: 'Nemate ispita koje možete prijaviti.',
        addNewContact: 'Dodavanje novog kontakta',
        noContactInfo: 'Nema kontakt informacija.',
        passedExamsNumber: 'Broj položenih ispita',
        noCurrentSemesterCourses: 'Niste upisani ni na jedan predmet u ovome semestru.',
        registeredStudentsList: 'Popis prijavljenih studenata',
        accountInfo: 'Podaci korisničkog računa',
        userRole: 'Korisničke uloge',
        editStudentData: 'Izmjena podataka o studentu',
        emailEditSuccess: 'Uspješno ste izmijenili e-mail!',
        emailEditError: 'Došlo je do pogreške! Izmjena e-maila nije izvršena.',
        contactConsentGiven: 'Uspješno ste dali suglasnost za prikazivanje vaših kontakt podataka.',
        contactConsentWithdrawn: 'Uspješno ste poništili suglasnost za prikazivanje vaših kontakt podataka.',
        currentlyEnrolled: 'Trenutno upisan',
        unfinalizedGradesNoticeHeader: 'Žutom bojom su označene ocjene koje još uvijek nisu finalizirane.',
        unfinalizedGradesNoticeContent: 'Ove ocjene se neće prikazivati na prijepisu ocjena dok ih profesor ne finalizira. U slučaju pogreške, obratite se odgovarajućem profesoru ili studentskoj službi.',
        selectOptionalCoursesWarning: 'Prilikom odabira izbornih predmeta potrebno je označiti i odabrati sve izborne predmete, u suprotnom odabir neće biti uspješan.',
        graduateInternship: 'Apsolventski staž',
        notEnrolled: 'nije upisan/a',
        semesterEnrollmentCount: '{semester} - {count}. put'

    },
    studentDocuments: {
        documentType: 'Vrsta dokumenta',
        status: 'Status',
        add: 'Kreiraj zahtjev',
        editRequest: 'Izmjena postojećeg zahtjeva',
        docRequest: 'Trenutni zahtjevi',
        createRequest: 'Kreiranje novog zahtjeva',
        requests: 'Dokumenti',
        send: 'Pošalji',
        certificateType: 'Vrsta potvrde',
        selectCertificateType: 'Izaberite vrstu potvrde',
        certificateReason: 'Statusna potvrda',
        selectCertificateReason: 'Izaberite statusnu potvrdu',
        selectLanguage: 'Izaberite jezik',
        writeComment: 'Napišite detalje zahtjeva',
        previousDocRequest: 'Prethodni zahtjevi',
        CurrentRequestMessage: 'Trenutno nemate aktivnih zahtjeva za dokumente.',
        PreviousRequestMessage: 'Nemate prethodnih zahtjeva za dokumente.',
        sentRequestToast: 'Zahtjev uspješno poslan.',
        errSentRequestToast: 'Došlo je do greške, zahtjev nije poslan.',
        errSentRequestDuplicateToast: 'Zahtjev za izdavanje ovog dokumenta je već kreiran.',
        cancelRequestToast: 'Zahtjev je poništen.',
        cancelPopup: 'Ovaj zahtjev će biti poništen!',
        showPopup: 'Prikaz prethodnih zahtjeva.',
        errInputToast: 'Niste unijeli sva polja!',
        nonCycleDocumentsInfoIntro: 'Ukoliko je student upisan na neciklični program, dostupne su opcije generisanja:',
        nonCycleDocumentsInfoBullet1: 'prepisa ocjena i',
        nonCycleDocumentsInfoBullet3: 'certifikata pod uvjetom da su u sustavu evidentirani datum završetka programa i broj certifikata.',
        nonCycleDocumentsInfoBullet4: 'dodatka certifikatu ako je prilikom kreiranja programa naznačeno da program ima dodatak certifikatu.'
    },
    professorInputGrades: {
        importTemplateInfo: 'Excel fajl sa spiskom neocijenjenih studenata u ispravnom formatu možete preuzeti klikom na dugme \'Preuzmite excel fajl neocijenjenih studenata\' u gornjem lijevom uglu.',
        downloadExcelWithoutGrades: 'Preuzmite excel fajl neocijenjenih studenata',
        importInfo1: 'Odabrana datoteka mora sadržavati sljedeće četiri stupce:',
        importInfo2: 'Ocjene moraju biti iz sljedećeg skupa:',
        importInfo3: 'Ako u excel datoteci postoje dupli studenti (isti indeks, ime i prezime), bit će upisana ocjena iz kasnijeg retka.',
        orderNotImportant: 'Redoslijed stupaca nije bitan.',
        missingRequiredFields: 'Redak {row}: Nedostaje jedno od obaveznih polja (Indeks, Ime, Prezime, Ocjena).',
        studentNotFound: 'Redak {row}: Student/ica "{firstName} {lastName}" s indeksom "{index}" nije pronađen/a među neocijenjenim studentima.',
        studentLockedOrDroppedOut: 'Student je zaključan/ispisan. Ukoliko trebate unijeti ocjenu iz ovog predmeta kontaktirajte studentsku službu.',
        enterGrade: 'Unesite ocjenu',
        uploadFile: 'Dodaj excel datoteku',
        invalidFormat: 'Neispravan format datoteke. Dozvoljena je samo .xlsx.',
        invalidGrade: 'Neispravna ocjena za studenta {index} ({ime}) – ocjena mora biti jedna od dozvoljenih.',
        noFileSelected: 'Niste odabrali datoteku.',
        invalidFileStructure: 'Struktura datoteke nije ispravna. Potrebni stupci: indeks, ime i prezime, ocjena.',
        submitImportedGrades: 'Potvrdi ocjene',
        importedGradesInfo: 'Učitane ocjene bit će prikazane u tablici. Nakon pregleda kliknite na gumb za dodjelu ocjena.',
        clearImportedGrades: 'Poništi uvezene ocjene',
        invalidRowsFound: 'Pronađene su neispravne ocjene. Provjerite i pokušajte ponovo.',
        noGrade: 'Nema ocjene',
        selectFile: 'Odaberite datoteku',
        uploadExcel: 'Učitaj excel datoteku s ocjenama',
        importSubmit: 'Pošalji ocjene',
        importFailed: 'Greška pri uvozu ocjena',
        importErrors: 'Greške prilikom uvoza ocjena',
        grade2: 'Ocjena',
        toastGradeImportSuccess: 'Ocjene su uspješno unesene.',
        toastGradeImportFailed: 'Greška prilikom uvoza ocjena.',
        finalizeInfo: 'Nakon što završite ispit svim neocijenjenim studentima sustav će dodijeliti ocjenu',
        finalizeInfo2: 'nije pristupio/la.',
        grade: 'Ocijeni',
        groupGrading: 'Grupno ocjenjivanje',
        groupGradingInfo: 'Grupno ocjenjivanje možete izvršiti tako što studente/ice sa istom ocjenom označite na listi ' +
            '(klikom na red tabele ili na kvadratić u prvoj koloni), potom izaberete ocjenu i klikom na ',
        groupGradingInfo2: 'Ocijeni',
        groupGradingInfo3: ' svim označenim studentima/icama će biti unesena odabrana ocjena.',
        individuallyGrading: 'Pojedinačno ocjenjivanje',
        infoView: 'Pregled podataka',
        info: 'Podaci',
        personalInfo: 'Osobni podaci',
        semesters: 'Pregled semestara',
        currentSemester: 'Trenutni semestar',
        studyInfo: 'Trenutni studij',
        finalizeCheck: 'Jeste li sigurni da želite završiti ispit?',
        endOfEmploymentDate: 'Datum prestanka radnog odnosa',
        endOfEmployment: 'Prestanak radnog odnosa',
        endOfEmploymentButton: 'Prekini radni odnos',
        contact: 'Kontakt informacije',
        inputGrades: 'Unos ocjena',
        selectCourse: 'Izaberite predmet',
        selectExamTerms: 'Izaberite vrstu ispita',
        selectGrade: 'Ocjena',
        examType: 'Vrsta ispita',
        attention: 'Izlaznost',
        registration: 'Prijave',
        passed: 'Prolaznost',
        course: 'Predmet',
        confirm: 'Potvrdi',
        studentsWithoutGrades: 'Popis neocijenjenih studenata',
        studentsWithGrades: 'Popis ocijenjenih studenata',
        studyYear: 'Studijska godina',
        department: 'Odsjek',
        studyProgram: 'Studijski program',
        studentStudyType: 'Vrsta studija',
        selectStudyType: 'Izaberite status studenta',
        selectStudyProgram: 'Izaberite smjer (studijski program)',
        selectDate: 'Izaberite datum ispita',
        graded: 'Ocijeni',
        edit: 'Izmijeni',
        confirmGrade: 'Potvrdi ocjenu',
        cancelGrade: 'Poništi ocjenu',
        filterData: 'Filtriraj podatke.',
        showTable: 'Prikaži ocijenjene studente.',
        CurrentGradesMessage: 'Nema neocijenjenih studenata.',
        CurrentGradesFilterMessage: 'Filtriranje je uključeno! Nema neocijenjenih studenata.',
        PreviousGradesMessage: 'Nema ocijenjenih studenata.',
        PreviousGradesFilterMessage: 'Filtriranje je uključeno! Nema ocijenjenih studenata.',
        PreviousNoGradesFilterMessage: 'Filtriranje je uključeno! Nema neocijenjenih studenata.',
        selectAcademicYear: 'Izaberite akademsku godinu',
        selectSemester: 'Izaberite semestar',
        examDate: 'Ispitni rok',
        examDateDate: 'Datum i vrijeme ispita',
        examFinalizationTime: 'Datum i vrijeme automatskog finaliziranja',
        examOnlyDate: 'Datum ispita',
        selectExamDate: 'Odaberite ispitni rok',
        showStudents: 'Prikaži studente',
        selectNewCourse: 'Odaberite drugi predmet',
        inputFirstName: 'Unesite ime',
        inputLastName: 'Unesite prezime',
        FiltersOn: 'Filtriranje uključeno!',
        getFilter: 'Filtriraj',
        finalize: 'ZAVRŠI   ISPIT',
        toastFilter: 'Odaberite po čemu želite filtrirati podatke!',
        toastFilterFailed: 'Filtriranje nije uspjelo',
        toastFilanizedExam: 'Ispit je završen!',
        toastStudentGraded: 'Student je uspješno ocijenjen!',
        toastStudentsGraded: 'Studenti su uspješno ocijenjeni!',
        toastStudentGradedFailed: 'Student nije ocijenjen, došlo je do greške!',
        toastStudentsGradedFailed: 'Studenti nisu ocijenjeni, došlo je do greške!',
        activeExamsList: 'Popis aktivnih (nezavršenih) ispita',
        NoDataMessage: 'Nema aktivnih ispita.',
        numberOfStudents: 'Broj prijavljenih studenata',
        gradeStudents: 'Ocjenjivanje',
        registeredStudents: 'Prijavljeni studenti',
        addToCalendar: 'Dodaj na kalendar',
        activeCourse: 'Aktivni ispiti',
        finalizedCourse: 'Završeni ispiti',
        finalizedCourseList: 'Popis završenih ispita',
        toastStudentGradeEdited: 'Ocjena je uspješno izmijenjena.',
        toastStudentGradeCancel: 'Ocjena je uspješno poništena.',
        toastStudentGradeEditFailed: 'Došlo je do greške, ocjena nije izmijenjena!',
        toastStudentGradeCancelFailed: 'Došlo je do greške, ocjena nije poništena!',
        startDate: 'Ispiti od:',
        endDate: 'Ispiti do:',
        NofinalizedExamsMessage: 'Nema završenih ispita.',
        endAndStartDate: 'Morate unijeti od kojeg do kojeg datuma želite ispite!',
        toastFinalizedFailed: 'Ispit nije završen!',
        NoUpcomingExamsMessage: 'Nemate predstojećih ispita.',
        upcomingExams: 'Predstojeći ispiti',
        upcomingExamsList: 'Popis predstojećih ispita',
        toastFinalized: 'Ispit je uspješno završen!',
        studentInfo: 'Podaci o studentu',
        showStudentInfo: 'Prikaži informacije o studentu',
        backToStudentsList: 'Nazad na popis studenata',
        gradesList: 'Popis ocjena',
        inputGradeDate: 'Datum unosa ocjene',
        positions: 'Radne pozicije',
        titles: 'Izbori u zvanje',
        inputCourseName: 'Unesite naziv predmeta',
        gradedStudentsNumber: 'Broj ocijenjenih studenata',
        averageGrade: 'Prosječna ocjena: ',
        noDataForAcademicYear: 'Nema podataka.',
        noCourses: 'Nema predmeta',
        noCoursesMessage: 'Nema predmeta za koje ste zaduženi ove akademske godine.',
        noCoursesMessageSS: 'Nema predmeta za koje je profesor/ica zadužen/a u odabranoj akademskoj godini.',
        noCoursesFilter: 'Filtriranje je uključeno! Nema predmeta.',
        gradedStudents: 'Ocijenjeni studenti',
        notGradedStudents: 'Neocijenjeni studenti',
        externalStudentGrades: 'Ocjene studenata dolazne mobilnosti',
        printGradesList: ' Ocijenjeni studenti po indexima',
        printStudentsList: ' Prijavljeni studenti',
        finalizationCancelDate: 'Datum ponovnog otvaranja ispita (odluka)',
        averageGradeNew: 'Prosječna ocjena',
        importSuccess: 'Ocjene su uspješno učitane.',
        importGrades: 'Import ocjena',
        methodName: 'Način ocjenjivanja',
        showStatistic: 'Prikaži u tabeli',
        statisticNote: '*Statistika obuhvata isključivo predmete od godine prelaska fakulteta na eUNSA sistem.',
        addMoreStatistic: 'Odaberite jedan ili više semestara prethodnih akademskih godina za poređenje statistike ovog predmeta',
        compareStatistics: 'Uporedi sa drugim godinama',
        showStatisticField: 'Prikazani podaci su za',
        selectAcademicYears: 'Izaberite akademske godine',
    },
    professorStatistics: {
        statistics: 'Statistika',
        numberOfStudents: 'Broj studenata na predmetu',
        averrageGrade: 'Prosjek ocjena',
        NoDataMessage: 'Nema podataka za ovu akademsku godinu.',
        currentAcademicYear: 'Trenutna akademska godina',
        studentsChart: 'Prikaz broja studenata po predmetu',
        gradeChart: 'Prikaz prosječne ocjene po predmetu',
        graphicShow: 'Grafički prikaz',
        tableShow: 'Tabelarni prikaz',
        courseId: 'Redni broj',
        selectAcademicYear: 'Odaberite akademsku godinu',
        academicYearHeader: ' akademska godina',
        courseStatistic: 'Statistika predmeta',
        statisticForCourse: 'Statistika za predmet: ',
        noStudents: 'Nema studenata.',
        noCourses: 'Nema podataka o odabranom predmetu.',
        noStudentsFilter: 'Filtriranje je uključeno! Nema studenata.',
        printRegisteredStudents: 'Tiskanje popisa prijavljenih studenata',
        printStudentGrades: ' Tiskanje popisa studenata sa ocjenama',
        notFinalRegisteredStudentsList: '*Popis prijavljenih studenata nije konačan, jer je ispit još uvijek otvoren za prijavu. ',
        noRegisteredStudents: 'Nema prijavljenih studenata.',
        studyProgramCourse: 'na kojem se izvodi predmet',
        courseExamDate: 'Naziv predmeta / vrsta ispita / datum',
        numberOfStudentsOnCourse: 'Broj studenata koji pohađaju predmet - n',
        numberOfDistinctStudentGradedActivities: 'Broj različitih prijavljenih studenata na svim ispitima - n₁',
        numberOfExamRegistrations: 'Ukupan broj prijava na svim ispitima',
        numberOfDistinctStudentsWhoAccessedExam: 'Broj različitih studenata koji su izašli na ispite - n₂',
        numberOfStudentsWhoAccessedExam: 'Ukupan broj izlazaka na svim ispitima',
        numberOfStudentsWhoPassed: 'Broj studenata koji su položili predmet - k',
        averagePassedStudentsOnCourse: 'Prolaznost - k/n',
        averagePassedDistinctStudentGradedActivities: 'Prolaznost - k/n₁',
        averagePassed: 'Prolaznost - k/n₂',
        five: '5 (pet)',
        six: '6 (šest)',
        seven: '7 (sedam)',
        eight: '8 (osam)',
        nine: '9 (devet)',
        ten: '10 (deset)',
        nonp: 'nije ocijenjen/nije pristupio',
        io: 'ispunio obveze',
        nz: 'nije zadovoljio',
        z: 'zadovoljio',
        no: 'nije obranio',
        uo: 'uspješno obranio',
        np: 'nije položio/la',
        na: 'nije pristupio/la',
        courseName: 'Naziv predmeta'
    },
    contact: {
        contact: 'Kontakt informacije',
        unsa: 'UNSA',

        selectCommentType: 'Odaberite vrstu komentara',
        inputMail: 'Unesite e-mail adresu',
        inputTitle: 'Unesite naslov',
        text: 'Tekst poruke...',
        text_: 'Tekst poruke',
        title: 'Naslov poruke',
        email: 'Vaša e-mail adresa',
        comments: 'Komentari i prijedlozi',
        form: 'Forma za slanje',
        errorMess: 'Niste unijeli sva obavezna polja.',
        mailValidationError: 'Mail adresa nije ispravna.',
        success: 'Vaš komentar / prijedlog je uspješno poslan.',
        error: 'Došlo je od greške! Vaš komentar / prijedlog nije poslan.',
        commentType: 'Vrsta napomene',
    },
    faq: {
        title: 'Najčešće postavljena pitanja',
        searchPlaceholder: 'Pretraži pitanja...',
        noResultsMessage: 'Ukoliko Vaše pitanje niste pronašli na ponuđenom popisu, možete nam se obratiti putem forme',
        commentsLink: 'komentari i prijedlozi.',
        showAnswer: 'Prikaži odgovor',
    },
    statistics: {
        statistic: 'Statistika',
        selectFacultyAndAcademicYear: 'Odaberite fakultet i akademsku godinu',
        selectFacultyAcademicYearAndStudyCycle: 'Odaberite fakultet, akademsku godinu i studijski ciklus',
        selectFaculty: 'Odaberite fakultet',
        selectAcademicYear: 'Odaberite akademsku godinu',
        selectStudyCycle: 'Odaberite studijski ciklus',
        citizenship: 'Državljani',
        selectCitizenship: 'Odaberite državljanstvo studenata',
        headerNumberEnrolledStudents: 'Broj upisanih studenata u prvi semestar ',
        headerAcademicYear: ' akademske godine',
        tableShow: 'Tabelarni prikaz',
        graphicShow: 'Grafički prikaz',
        place: 'Mjesto',
        numberOfStudents: 'Broj studenata',
        headerNumberEnrolledStudentsPerStudyCycles: 'Broj upisanih studenata u prvi semestar po studijskom ciklusu ',
        studentsNumber: 'Ukupan broj studenata: ',
        headerNumberEnrolledStudentsPerStudyTypes: 'Broj upisanih studenata u prvi semestar prema statusu studiranja ',
        headerNumberEnrolledStudentsPerAcademicYearsAndCycles: 'Broj upisanih studenata po studijskim godinama i ciklusima ',
        studyYear: 'Godina studija',
        headerNumberGraduatedStudentsPerStudyCycles: 'Broj studenata koji su završili određeni studijski ciklus ',
        headerNumberGraduatedStudents: 'Broj studenata koji su završili',
        graduated: 'diplomanata',
        enrollledBiH: 'Upisanih BH državljana',
        enrolledOther: 'Upisanih stranih državljana',
        graduatedStudents: 'Diplomirani studenti',
        perCyclesForFaculty: 'Po ciklusima za fakultet',
        perCyclesForFacultyMF: 'Po ciklusima za fakultet (M/Ž)',
        perCyclesForUniversity: 'Po ciklusima za Univerzitet',
        enrolledPerFaculty: 'Upisani studenti po fakultetima',
        perCycles: 'Po ciklusima',
        perStudyType: 'Prema statusu studiranja',
        perCountries: 'Po državama',
        perStudyYearAndCycles: 'Po studijskim godinama i ciklusima',
        perMunicipality: 'Po BH općinama',
        enrolledForUniversity: 'Upisani studenti na Univerzitetu',
    },
    externalStudent: {
        filterStudents: 'Pretraga studenata',
        createStudent: 'Kreiranje studenta',
        externalStudents: 'Studenti dolazne mobilnosti',
        externalStudent: 'Student dolazne mobilnosti',
        addingExternalStudent: 'Dodavanje studenta dolazne mobilnosti',
        students: 'Studenti dolazne mobilnosti',
        academicYear: 'Akademska godina',
        selectAcademicYear: 'Odaberite akademsku godinu',
        faculty: 'Fakultet',
        selectFaculty: 'Odaberite fakultet',
        country: 'Država',
        selectCountry: 'Odaberite državu',
        fullName: 'Ime i prezime',
        dateOfBirth: 'Datum rođenja',
        fieldOfEducation: 'Oblast studija',
        studyCycle: 'Ciklus studija',
        sendingInstitution: 'Matična institucija',
        university: 'Univerzitet',
        sendingInstitutionCountry: 'Država matične institucije',
        erasmusCode: 'Erasmus kod',
        contactPerson: 'Kontakt osoba',
        email: 'Email',
        enterEmail: 'Unesite email',
        phone: 'Telefon',
        exchangeEnded: 'Student/ica je završio/la razmjenu dana {date}',
        exchangeEndsOn: 'Student/ica završava razmjenu dana {date}',
        exchangeEndedAlt: 'Student/ica je završio/la razmjenu akademske {academicYear} godine',
        exchangeEndsOnSummer: 'Student/ica završava razmjenu na kraju ljetnog semestra akademske {academicYear} godine',
        exchangeEndsOnWinter: 'Student/ica završava razmjenu na kraju zimskog semestra akademske {academicYear} godine',
        downloadExcel: 'Preuzmi spisak u Excel-u',
        createExternalStudent: 'Kreiranje studenta dolazne mobilnosti',
        enterPersonalAndInstitutionData: 'Osnovni podaci studenta dolazne mobilnosti',
        enterPersonalAndInstitutionDataPublic: 'Unesite lične podatke i podatke vaše matične institucije',
        confirm: 'Potvrdi',
        clear: 'Očisti',
        loading: 'Učitavanje...',
        personalData: 'Lični podaci',
        cancel: 'Odustani',
        edit: 'Izmijeni',
        firstName: 'Ime',
        enterFirstName: 'Unesite ime',
        lastName: 'Prezime',
        enterLastName: 'Unesite prezime',
        birthDate: 'Datum rođenja',
        enterBirthDate: 'Unesite datum rođenja',
        gender: 'Spol',
        selectGender: 'Odaberite spol',
        englishLevelCompetence: 'Nivo poznavanja engleskog jezika',
        selectEnglishLevelCompetence: 'Odaberite nivo poznavanja engleskog jezika',
        esi: 'ESI - Evropski studentski identifikator',
        enterEsi: 'Unesite Evropski identifikator studenta',
        exchangeData: 'Podaci o razmjeni',
        mobilityProgram: 'Program mobilnosti',
        selectMobilityProgram: 'Odaberite program mobilnosti',
        mobilityType: 'Tip mobilnosti',
        selectMobilityType: 'Odaberite tip mobilnosti',
        externalStudentSemester: 'Semestar',
        selectExternalStudentSemester: 'Odaberite semestar',
        mobilityFormat: 'Dužina mobilnosti',
        selectMobilityFormat: 'Odaberite dužinu mobilnosti',
        dateFrom: 'Datum početka programa',
        enterDateFrom: 'Unesite datum početka programa',
        dateTo: 'Datum završetka programa',
        enterDateTo: 'Unesite datum završetka programa',
        selectStudyCycle: 'Odaberite ciklus studija',
        selectFieldOfEducation: 'Odaberite područje obrazovanja',
        sendingInstitutionData: 'Matična institucija',
        institutionName: 'Naziv institucije',
        enterInstitutionName: 'Unesite naziv institucije',
        institutionFaculty: 'Fakultet',
        enterInstitutionFaculty: 'Unesite naziv fakulteta',
        institutionDepartment: 'Odsjek',
        enterInstitutionDepartment: 'Unesite naziv odsjeka',
        institutionErasmusCode: 'Erasmus kod',
        enterInstitutionErasmusCode: 'Unesite erasmus kod',
        institutionCountry: 'Država',
        selectInstitutionCountry: 'Odaberite državu',
        institutionAddress: 'Adresa',
        enterInstitutionAddress: 'Unesite adresu institucije',
        contactPersonFirstName: 'Ime kontakt osobe',
        enterContactPersonFirstName: 'Unesite ime kontakt osobe',
        contactPersonLastName: 'Prezime kontakt osobe',
        enterContactPersonLastName: 'Unesite prezime kontakt osobe',
        contactPersonEmail: 'Email kontakt osobe',
        enterContactPersonEmail: 'Unesite email kontakt osobe',
        contactPersonPhone: 'Telefon kontakt osobe',
        enterContactPersonPhone: 'Unesite telefon kontakt osobe',
        studentProfile: 'Profil studenta',
        basicInformation: 'Osnovni podaci',
        faculties: 'Fakulteti',
        grades: 'Ocjene',
        back: 'Nazad',
        nameAndSurname: 'Ime i prezime',
        ordinalNumber: 'R. br.',
        facultyName: 'Ime fakulteta',
        indexNumber: 'Broj indeksa',
        enterIndexNumber: 'Unesite broj indeksa',
        contactFirstName: 'Ime kontakt osobe',
        contactLastName: 'Prezime kontakt osobe',
        contactEmail: 'Email kontakt osobe',
        contactPhone: 'Telefon kontakt osobe',
        mainOrganizationalUnit: 'Glavna organizaciona jedinica',
        add: 'Dodaj',
        save: 'Sačuvaj',
        delete: 'Brisanje',
        noFaculties: 'Nema fakulteta za prikaz.',
        studyProgramOrActivityType: 'Studijski program / Tip aktivnosti',
        studyProgram: 'Studijski program',
        courseOrActivity: 'Predmet / Aktivnost',
        course: 'Predmet',
        ects: 'ECTS',
        professor: 'Profesor',
        attendanceType: 'Način pohađanja nastave',
        examDate: 'Datum održavanja ispita',
        grade: 'Ocjena',
        selectGrade: 'Odaberite ocjenu',
        otherActivityTypes: 'Ostali tipovi aktivnosti',
        selectActivityType: 'Odaberite tip aktivnosti',
        selectStudyProgram: 'Odaberite studijski program',
        enterActivityName: 'Unesite naziv aktivnosti',
        selectCourse: 'Odaberite predmet',
        enterEcts: 'Unesite broj ECTS bodova',
        selectProfessor: 'Odaberite profesora',
        selectAttendanceType: 'Odaberite način pohađanja nastave',
        enterExamDate: 'Unesite datum održavanja ispita',
        noGrades: 'Nema ocjena za prikaz.',
        documents: 'Dokumenti',
        birthCountry: 'Država rođenja',
        selectBirthCountry: 'Odaberite državu rođenja',
        citizenshipCountry: 'Državljanstvo',
        selectCitizenshipCountry: 'Odaberite državljanstvo',
        birthPlaceName: 'Mjesto rođenja',
        enterBirthPlaceName: 'Unesite mjesto',
        jmbg: 'JMBG / Broj pasoša',
        enterJmbg: 'Unesite JMBG / Broj pasoša',
        studyType: 'Tip studija',
        selectStudyType: 'Odaberite tip studija',
        programName: 'Naziv programa',
        enterProgramName: 'Unesite naziv programa',
        dropoutDate: 'Datum ispisa',
        enterDropoutDate: 'Unesite datum ispisa',
        lockedAt: 'Datum zaključavanja',
        enterLockedAt: 'Unesite datum zaključavanja',
        unlockStudent: 'Otključaj studenta/icu',
        expiresAt: 'Datum isteka registracijskog linka',
        enterExpiresAt: 'Unesite datum isteka registracijskog linka',
        submit: 'Potvrdi',
        isced: 'prema ISCED-u 2013',
        registrationLinks: 'Registracijski linkovi',
        registeredStudents: 'Prijavljeni studenti',
        registeredStudentsUsingLink: 'Prijavljeni studenti putem linka',
        noAccessToDocumentsTab: 'Only student service from main organizational unit has access to the Documents tab.',
        registrationLinkNotFoundOrExpired: 'Registracijski link nije pronađen ili je istekao.',
        successfullySubmittedData: 'Vaši podaci su uspješno poslani!',
        closeThisPageSafely: 'Možete sigurno zatvoriti ovu stranicu.',
        completionDetails: 'Podaci o završetku',
        enterCompletionDetails: 'Unesite podatke o završetku',
        graduationDate: 'Datum završetka',
        enterGraduationDate: 'Unesite datum završetka',
        certificateNumber: 'Broj certifikata',
        enterCertificateNumber: 'Unesite broj certifikata',
        filledByReceivingInstitution: 'Ovu sekciju je popunila institucija domaćin.',
        validUntil: 'Validan do',
        numberOfSignedUp: 'Broj prijavljenih',
        mobilityProgramPeriod: 'Period mobilnosti / programa',
        organizationalUnit: 'Organizaciona jedinica',
        loadAgain: 'Učitaj ponovo',
        createRegistrationLink: 'Kreirajte novi registracijski link',
        registrationLinksForMobilityStudents: 'Registracijski linkovi za studente u mobilnosti',
        copyRegistrationLink: 'Kopiraj registracijski link',
        openRegistrationLink: 'Otvori registracijski link',
        editRegistrationLink: 'Uredi registracijski link',
        deleteRegistrationLink: 'Obriši registracijski link',
        signedUpStudents: 'Prijavljeni studenti',
        cyclicalStudyProgram: 'Ciklični studij',
        nonCyclicalStudyProgram: 'Neciklični studij',
        mobilityTypeInfoCyclical: 'Mobilnost po semestrima (1 ili 2 semestra).',
        mobilityTypeInfoNonCyclical: 'Mobilnost od datuma do datuma (ljetne / zimske škole, prakse, istraživački radovi).',
        programNameInfo: 'Naziv programa mobilnosti (npr. Erasmus+ Blended Intensive Program) ili, ako je riječ o cikličnom studiju, naziv studijskog programa (npr. Računarstvo i informatika).',
        erasmusCodeInfo: 'Erasmus kod matične institucije studenta/ice u mobilnosti. Za ovu informaciju obratite se matičnoj instituciji ili administraciji fakulteta.',
        studyCycleInfo: 'Ciklus studija na koji je student/ica upisan/a na matičnoj instituciji.',
        courseEnrollment: 'Predmeti',
        registrationLinkExpiredExplanation: 'Ovaj registracijski link više nije važeći ili je istekao. Molimo kontaktirajte Službu za međunarodnu saradnju ili prijemnu organizacionu jedinicu za daljnje upute.',
        activityTypes: 'Tipovi aktivnosti: ',
        studyPrograms: 'Studijski programi: ',
        consentText: 'Saglasan/na sam da se moji lični podaci prikupljaju i obrađuju u svrhu obrade prijave za mobilnost, u skladu sa važećim propisima o zaštiti podataka.',
        courseCodeAlt: 'Šifra',
        courseCode: 'Šifra predmeta',
        enterCourseCode: 'Unesite šifru predmeta',
        lectureNumberAlt: 'P',
        lectureNumber: 'Broj sati predavanja',
        enterLectureNumber: 'Unesite broj predavanja',
        exerciseNumberAlt: 'V',
        exerciseNumber: 'Broj sati vježbi',
        enterExerciseNumber: 'Unesite broj vježbi',
        otherNumberAlt: 'O',
        otherNumber: 'Ostali sati',
        enterOtherNumber: 'Unesite ostale sate',
        nonGradedWarning: 'Student/ica je neocijenjen/a na sljedećim predmetima:',
        programLead: 'Voditelj programa',
        selectProgramLead: 'Odaberite voditelja programa',
        lectureAndExerciseNumber: 'Broj sati predavanja / vježbi / ostalih',
        documentsInfoCycleIntro: 'Ukoliko je student upisan na ciklični studijski program, dostupne su opcije generisanja:',
        documentsInfoCycleBullet1: 'prepisa ocjena i',
        documentsInfoCycleBullet2: 'statusne potvrde.',
        documentsInfoNonCycleIntro: 'Ukoliko je student upisan na neciklični program, dostupne su opcije generisanja:',
        documentsInfoNonCycleBullet1: 'prepisa ocjena i',
        documentsInfoNonCycleBullet2: 'statusne potvrde.',
        documentsInfoNonCycleBullet3: 'certifikata pod uvjetom da su u sustavu evidentirani datum završetka programa i broj certifikata.',
        documentsInfoNonCycleBullet4: 'dodatka certifikatu ako je prilikom kreiranja programa naznačeno da program ima dodatak certifikatu.',
        //
        createNonCycleStudyProgramStudent: 'Kreiranje studenta na necikličnom studijskom programu',
        enterPersonalAndNonCycleStudyProgramData: 'Unesite osobne podatke i podatke o necikličnom studijskom programu',
        nonCycleStudyProgramData: 'Podaci o necikličnom studijskom programu',
        nonCycleProgram: 'Neciklični program',
        selectNonCycleProgram: 'Odaberite neciklični program',
        nonCycleStudyProgramType: 'Vrsta necikličnog studijskog programa',
        selectNonCycleStudyProgramType: 'Odaberite vrstu necikličnog studijskog programa',
        mainFieldOfStudy: 'Glavno područje programa',
        enterMainFieldOfStudy: 'Unesite glavno područje programa',
        programStructure: 'Struktura programa',
        enterProgramStructure: 'Unesite strukturu programa',
        programDurationMonths: 'Trajanje programa u mjesecima',
        enterProgramDurationMonths: 'Unesite trajanje programa u mjesecima',
        programDurationEcts: 'Trajanje programa u ECTS bodovima',
        enterProgramDurationEcts: 'Unesite trajanje programa u ECTS bodovima',
        accessRequirements: 'Uvjeti pristupa',
        enterAccessRequirements: 'Unesite uvjete pristupa (uvjete upisa)',
        programAttendanceType: 'Način pohađanja programa',
        selectProgramAttendanceType: 'Odaberite način pohađanja programa',
        competencies: 'Kompetencije',
        enterCompetencies: 'Unesite kompetencije',
        learningOutcomes: 'Ishodi učenja',
        enterLearningOutcomes: 'Unesite ishode učenja',
        professionalStatus: 'Profesionalni status',
        enterProfessionalStatus: 'Unesite profesionalni status',
        additionalInformation: 'Dodatne informacije',
        additionalInformationEng: 'Dodatne informacije na engleskom',
        enterAdditionalInformation: 'Unesite dodatne informacije',
        enterAdditionalInformationEng: 'Unesite dodatne informacije na engleskom',
        sourcesOfAdditionalInformation: 'Izvori dodatnih informacija',
        enterSourcesOfAdditionalInformation: 'Unesite izvore dodatnih informacija',
        nonCycleStudyProgram: 'Neciklični studij',
        nonCycleStudyProgramStudents: 'Studenti na necikličnim studijskim programima',
        selectOrganizationalUnit: 'Odaberite organizacijsku jedinicu',
        jmbgAlt: 'JMBG',
        enterJmbgAlt: 'Unesite JMBG',
        studyProgramLanguage: 'Jezik izvođenja nastave',
        selectStudyProgramLanguage: 'Odaberite jezik izvođenja nastave',
        programInformation: 'Informacije o programu',
        programStructureAndDuration: 'Struktura i trajanje programa',
        completedProgramAndLearningOutcomes: 'Informacije o završenom programu i postignutim rezultatima',
        programPurpose: 'Informacije o svrsi programa',
        connectExistingStudent: 'Poveži s postojećim studentom',
        findStudent: 'Pronađi studenta',
        student: 'Student',
        selectStudent: 'Odaberite studenta',
        selectTemplate: 'Odaberite predložak',
        template: 'Predložak',
        templateName: 'Naziv predloška',
        enterTemplateName: 'Unesite naziv predloška',
        saveTemplate: 'Spremi predložak',
        scholarshipAmount: 'Iznos stipendije (u EUR)',
        enterScholarshipAmount: 'Unesite iznos stipendije (u EUR)',
        languages: 'Jezici izvođenja nastave',
        selectLanguages: 'Odaberite jezike izvođenja nastave',
        nonCyclePrograms: 'Neciklični programi',
        createNonCycleProgram: 'Kreiranje necikličnog programa',
        editNonCycleProgram: 'Uredi neciklični program',
        deleteNonCycleProgram: 'Obriši neciklični program',
        programNameEn: 'Naziv programa (engleski)',
        enterProgramNameEn: 'Unesite naziv programa na engleskom',
        mainFieldOfStudyEn: 'Glavno područje programa (engleski)',
        enterMainFieldOfStudyEn: 'Unesite glavno područje programa na engleskom',
        programStructureEn: 'Struktura programa (engleski)',
        enterProgramStructureEn: 'Unesite strukturu programa na engleskom',
        accessRequirementsEn: 'Uslovi pristupa (engleski)',
        enterAccessRequirementsEn: 'Unesite uslove pristupa na engleskom',
        learningOutcomesEn: 'Ishodi učenja (engleski)',
        enterLearningOutcomesEn: 'Unesite ishode učenja na engleskom',
        professionalStatusEn: 'Profesionalni status (engleski)',
        enterProfessionalStatusEn: 'Unesite profesionalni status na engleskom',
        additionalInformationEn: 'Dodatne informacije (engleski)',
        enterAdditionalInformationEn: 'Unesite dodatne informacije na engleskom',
        sourcesOfAdditionalInformationEn: 'Izvori dodatnih informacija (engleski)',
        enterSourcesOfAdditionalInformationEn: 'Unesite izvore dodatnih informacija na engleskom',
        nonCycleProgramStudents: 'Studenti na necikličnom programu',
        groupGraduating: 'Unos datuma završetka programa',
        confirmGroupGraduation: 'Potvrdi',
        cancelGroupGraduation: 'Odustani',
        gradesInfo: 'U ovom tabu prikazani su svi studenti koji su predmet upisali u okviru ciklične mobilnosti (npr. kroz programe Erasmus+, CEEPUS i druge slične programe međunarodne razmjene).\n' +
            '\n' +
            'Za navedene studente omogućena je korekcija datuma ocjene, ukoliko se ocjena unosi na datum koji odstupa od predviđenog redovnog ispitnog roka. Ova opcija je dostupna isključivo za studente u mobilnosti.',
        includeGraded: 'Uključi ocijenjene',
        comment: 'Komentar',
        enterComment: 'Unesite komentar',
        programHasCertificateSupplement: 'Po završetku programa se dodjeljuje dodatak certifikatu (Certificate Supplement) koji sadrži detaljne informacije o programu, postignutim rezultatima i kompetencijama.',
        programHasCertificateSupplementShort: 'Program uključuje dodatak certifikatu',
        programEnrolmentYear: 'Godina upisa na program',
        toast: {
            requireFacultyOrDepartment: 'Potrebno je unijeti barem jednu od stavki: Fakultet ili Odsjek.',
            startDateBeforeEndDate: 'Datum početka mora biti prije datuma završetka.',
            createError: 'Greška pri kreiranju studenta.',
            createSuccess: 'Student je uspješno kreiran. Potrebno je unijeti podatke za pripadajuće fakultete.',
            requireFaculty: 'Unos fakulteta je obavezan.',
            duplicateOrganizationalUnit: 'Nije moguće dodati istu organizacionu jedinicu više puta!',
            singleMainOrganizationalUnit: 'Samo jedna organizaciona jedinica može biti glavna.',
            facultyAdded: 'Fakultet uspješno dodan.',
            facultyDeleted: 'Fakultet uspješno obrisan.',
            facultyUpdated: 'Fakultet uspješno ažuriran.',
            facultyDeleteErrorLinked: 'Nije moguće obrisati fakultet sve dok je student upisan na predmet sa tog fakulteta!',
            facultyDeleteError: 'Greška pri brisanju fakulteta!',
            saveError: 'Greška pri spremanju podataka!',
            fillRequiredFields: 'Potrebno je popuniti sva obavezna polja.',
            duplicateCourse: 'Nije moguće dodati isti predmet više puta!',
            courseAdded: 'Predmet uspješno dodan.',
            courseDeleted: 'Predmet uspješno obrisan.',
            courseUpdated: 'Predmet uspješno ažuriran.',
            editSuccess: 'Uspješno ste uredili studenta!',
            editError: 'Greška prilikom uređivanja studenta.',
            errorWhileSubmittingData: 'Došlo je do greške prilikom slanja vaših podataka.',
            errorFetchingData: 'Došlo je do greške pri dobavljanju podataka.',
            registrationLinkDeleted: 'Registracijski link je uspješno obrisan.',
            registrationLinkCreated: 'Registracijski link je uspješno kreiran.',
            registrationLinkEdited: 'Registracijski link je uspješno ažuriran.',
            registrationLinkCopied: 'Registracijski link je uspješno kopiran.',
            nonCycleProgramCreated: 'Neciklični program je uspješno kreiran.',
            nonCycleProgramEdited: 'Neciklični program je uspješno ažuriran.',
            nonCycleProgramDeleted: 'Neciklični program je uspješno obrisan.',
            studentSuccessfullyDeleted: 'Student je uspješno obrisan.',
            unlockSuccess: 'Student/ica je uspješno otključan/a.',
            unlockError: 'Greška pri otključavanju studenta/ice.',
            //
            firstAndLastNameRequired: 'Potrebno je unijeti ime i prezime.',
            templateSaveSuccess: 'Predložak je uspješno spremljen.',
            templateSaveError: 'Greška pri spremanju predloška.',
            groupGraduationSuccess: 'Datumi završetka su uspješno sačuvani.',
        }
    },
    semesterManagement: {
        toast: {
            fillRequiredFields: 'Potrebno je popuniti sva obavezna polja.',
            startDateBeforeEndDate: 'Datum početka mora biti prije datuma završetka.',
            semesterEdited: 'Semestar uspješno ažuriran.',
            semesterCreated: 'Semestar uspješno kreiran.',
            saveError: 'Greška pri spremanju podataka!',
        },
        confirm: 'Potvrdi',
        cancel: 'Odustani',
        academicYear: 'Akademska godina',
        selectAcademicYear: 'Odaberite akademsku godinu',
        semesterType: 'Tip semestra',
        semesterTypeSelect: 'Odaberite tip semestra',
        semesterStartDate: 'Datum početka semestra',
        semesterEndDate: 'Datum završetka semestra',
        startDateOfEarlyEnrollment: 'Datum početka prijevremenog upisa'

    },
    assets: {
        common: {
            orgUnit: 'Organizaciona jedinica',
            send: 'Pošalji',
            edit: 'Uredi',
            cancel: 'Odustani',
            filtersOn: 'Filter uključen',
            filter: 'Filtriraj podatke',
            noData: 'Nema podataka',
        },
        vehicles: {
            title: 'Vozila',
            add: 'Dodavanje novog vozila',
            edit: 'Uređivanje vozila',
            about: 'O vozilu',
            manufacturer: 'Proizvođač',
            model: 'Model',
            type: 'Tip',
            vehicleSpecification: 'Specifikacije vozila',
            licencePlate: 'Tablice',
            chassisNumber: 'Broj šasije',
            numberOfSeats: 'Broj sjedišta',
            productionYear: 'Godina proizvodnje',
            purchaseYear: 'Godina nabavke',
            status: 'Status',
            fuelType: 'Tip goriva',
            listOfVehicles: 'Spisak vozila',
            deleteError: 'Došlo je do greške! Brisanje nije uspješno izvršeno.',
            deleteConstraintError: 'Nije moguće obrisati vozilo jer se koristi u drugim zapisima!',
        },
        organizationalUnitProperties: {
            deleteError: 'Greška pri brisanju.',
            deleteConstraintError: 'Nije moguće obrisati imovinu jer se koristi u drugim zapisima!',
        },
        equipment: {},
        leases: {
            deleteError: 'Greška pri brisanju ugovora!',
            deleteConstraintError: 'Nije moguće obrisati ugovor jer se koristi u drugim zapisima!',
        },
        leaseholders: {
            addressDeleted: 'Uspješno brisanje adrese!',
            addressDeleteError: 'Došlo je do greške prilikom brisanja adrese!',
            contactDeleted: 'Uspješno brisanje kontakta!',
            contactDeleteError: 'Došlo je do greške prilikom brisanja kontakta!',
            deleteError: 'Greška pri brisanju zakupca!',
            deleteConstraintError: 'Nije moguće obrisati zakupca jer postoje vezani ugovori!',
            addressDeleteConstraintError: 'Nije moguće obrisati adresu jer se koristi u drugim zapisima!',
            contactDeleteConstraintError: 'Nije moguće obrisati kontakt jer se koristi u drugim zapisima!',
        },
        rooms: {
            deleteError: 'Nije uspješno brisanje!',
            roomOrgUnitPropertyDeleteConstraintError: 'Nije moguće obrisati stavku jer se koristi u drugim zapisima!',
        },
    },
    announcements: {
        announcements: 'Obavještenja',
        noAnnouncements: 'Trenutno nema obavještenja za prikaz.',
        showContent: 'Prikaži sadržaj',
        hideContent: 'Sakrij sadržaj',
        searchPlaceholder: 'Pretraži obavještenja...',
        roleAdministrator: 'Administrator',
        roleAida: 'AIDA',
        roleInternationalCooperationOffice: 'Služba za međunarodnu suradnju',
    }
};



// WEBPACK FOOTER //
// ./src/messages/messages_hr.js